export type CookieConsent = 'accepted' | 'rejected';

export const COOKIE_CONSENT_KEY = 'evanota_cookie_consent';
export const GA_MEASUREMENT_ID = 'G-DVD35M61ZE';

declare global {
    interface Window {
        dataLayer?: unknown[];
        gtag?: (...args: unknown[]) => void;
    }
}

let analyticsLoaded = false;

export function getConsent(): CookieConsent | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const value = window.localStorage.getItem(COOKIE_CONSENT_KEY);

    if (value === 'accepted' || value === 'rejected') {
        return value;
    }

    return null;
}

export function acceptConsent(): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    loadGoogleAnalytics();
}

export function rejectConsent(): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
    clearAnalyticsCookies();
}

export function loadGoogleAnalytics(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    if (!import.meta.env.PROD || analyticsLoaded || getConsent() !== 'accepted') {
        return;
    }

    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
        analyticsLoaded = true;

        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        // Google's snippet pushes the Arguments object, not a rest-args array.
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer?.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    analyticsLoaded = true;
}

function clearAnalyticsCookies(): void {
    if (typeof document === 'undefined') {
        return;
    }

    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
        const name = cookie.split('=')[0]?.trim() ?? '';

        if (name === '_ga' || name === '_gid' || name.startsWith('_ga_') || name.startsWith('_gat')) {
            document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
        }
    }
}
